import { queryOptions } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import {
	indexInvoiceRecipientByClient,
} from "~/modules/billing/api/invoiceRecipient/invoiceRecipientApiDispatchers.ts";

export const invoiceRecipientQueries = {
	baseKey: ["invoice-recipient"],
	byClient: (clientId: string) =>
		queryOptions({
			queryKey: [...invoiceRecipientQueries.baseKey, "client", clientId],
			queryFn: () => indexInvoiceRecipientByClient(clientId).then(getDataFromResponse),
			enabled: !!clientId,
		}),
};